import csv from 'assets/images/csv.svg';
import styled from 'styled-components';

const AllFileTypePreview = ({
  file,
  embedPreviewConf,
  imgPreviewConf,
  embedWidth,
  videoPreviewConf,
  isControls = false,
  isCover = false,
}) => {
  const isPdf = (type) => type === 'application/pdf';
  const isMp4 = (type) => type === 'video/mp4';
  const isCsv = (type) => type === 'text/csv';

  if (isPdf(file?.type))
    return (
      <>
        <SEmbed
          embedPreviewConf={embedPreviewConf}
          src={file.url}
          width={embedWidth}
        />
        {isCover ? <SCoverEmbed /> : ''}
      </>
    );

  if (isMp4(file?.type))
    return (
      <SVideo
        playsInline
        src={file.url}
        videoPreviewConf={videoPreviewConf}
        controls={isControls}
      />
    );

  if (isCsv(file?.type))
    return (
      <SImage imgPreviewConf={imgPreviewConf} src={csv} alt={file.title} />
    );

  return (
    <SImage imgPreviewConf={imgPreviewConf} src={file.url} alt={file.title} />
  );
};

const SImage = styled.img`
  display: block;
  height: 100%;
  ${({ imgPreviewConf }) => imgPreviewConf}
`;
const SVideo = styled.video`
  display: block;
  height: auto;
  max-height: 55px;
  width: auto;
  ${({ videoPreviewConf }) => videoPreviewConf}
`;
const SEmbed = styled.embed`
  display: block;
  height: 100%;
  max-height: 60px;
  width: 80px;
  & > * {
    -webkit-touch-callout: none; /* iOS Safari */
    -webkit-user-select: none; /* Safari */
    -khtml-user-select: none; /* Konqueror HTML */
    -moz-user-select: none; /* Old versions of Firefox */
    -ms-user-select: none; /* Internet Explorer/Edge */
    user-select: none;
  }
  ${({ embedPreviewConf }) => embedPreviewConf}
`;
const SCoverEmbed = styled.span`
  position: absolute;
  width: 100%;
  height: 100%;
  z-index: 1;
`;

export default AllFileTypePreview;
